<template>
  <div class="demo-guide-step" @mouseenter="handleIn" :mouseleave="handleOut">
    <div class="demo-guide__line-wrap">
      <div class="demo-guide-step__icon-bg">
        <slot name="icon"></slot>
      </div>
      <div class="demo-guide-step__line"></div>
    </div>
    <div class="demo-guide-step__content-wrap">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DemoGuideStep",
  props: {
    handleMouseOver: {
      type: Function,
      required: false,
      default: () => false,
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    handleIn() {
      this.handleMouseOver(this.index);
    },
    handleOut() {
      this.handleMouseOver(null);
    },
  },
};
</script>

<style scoped>
.demo-guide-step {
  display: flex;
  align-items: stretch;
  color: var(--full-blue);
  padding: 20px;
  border-radius: 10px;
  transition: background 0.2s;
}

.demo-guide-step:hover {
  background: rgba(0, 0, 0, 0.05);
}

.demo-guide-step__line-wrap {
  position: relative;
  display: flex;
  justify-content: center;
}

.demo-guide-step__line {
  width: 1px;
  height: calc(100% + 10px);
  background: #c8d0d6;
  margin: 0 auto;
}

.demo-guide-step__icon-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 25px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
}

.demo-guide-step__content-wrap {
  padding-top: 5px;
  padding-left: 20px;
}

.demo-guide-step:last-child .demo-guide-step__line {
  display: none;
}
</style>
